// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { BudgetEnforcementLevel } from "@insite/client-framework/Store/Pages/BudgetManagement/BudgetManagementReducer";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    enforcementLevel: BudgetEnforcementLevel;
    extendedStyles?: EnforcementLevelDisplayStyles;
}

type Props = OwnProps;

export interface EnforcementLevelDisplayStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    // XNG-Changes
    wrapper?: InjectableCss;
}

export const enforcementLevelDisplayStyles: EnforcementLevelDisplayStyles = {
    labelText: {
        as: "h3",
        variant: "h6",
        css: css`
            display: inline-block;
        `,
    },
};

const EnforcementLevelDisplay: React.FunctionComponent<Props> = props => {
    const [styles] = React.useState(() => mergeToNew(enforcementLevelDisplayStyles, props.extendedStyles));

    let enforcementText;
    switch (props.enforcementLevel) {
        case "None":
            enforcementText = translate("No Enforcement");
            break;
        case "ShipTo":
            enforcementText = translate("Customer Ship To Level");
            break;
        case "Customer":
            enforcementText = translate("Customer Level");
            break;
        case "User":
            enforcementText = translate("User Level");
            break;
    }

    return (
        // XNG-Changes: adding a wrapper for styling on mobile
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.labelText}>{siteMessage("Budget_CurrentEnforcementLevel")}:</Typography>
            <Typography {...styles.valueText}>{enforcementText}</Typography>
        </StyledWrapper>
    );
};

export default EnforcementLevelDisplay;
